
<div style="width: 100%;height: 100%;display: flex;justify-content: center;">
    <div style="width: 90%;height: 100%;display: flex;">

        <div id="feedbox" style="width: 47.5%;height: 100%;">
                <div class="cardHeader fontAndFamily"  style="height: 6%;font-weight: bold;max-height: 35px;">
                     News    
                </div>
                <div style="height: 2%;"></div>
    
                <div class="cardBodyHolder" style="height: 89% !important;">
                      <div *ngFor="let feed of feeds" class="cardBodyLarge " style="display: flex;" (click)="detailView('feeds',feed.id)">
                            <div style="width: 15%; height: 100%; padding: 6px;">
                                <div style="width: 100%; height: 100%;">
                                    <img *ngIf="isMetadataAvailable(feed)" [src]="feed.linkMetaData?.image" style="width: 100%; height: 100%;" />
                                    <img *ngIf="!isMetadataAvailable(feed)" src="../assets/link.png" style="width: 100%; height: 100%;" />
                                </div>
                            </div>
                            <div style="width: 83%; height: 100%; margin-left: 4px;">
                                <div style="width: 100%; height: 100%;">
                                    <div style="width: 100%; height: 45%; display: flex;">
                                        <div style="width: 94%; height: 100%; display: flex; padding-top: 2%;">
                                            <span class="elipsis-text headdingColourAndWeight" style="width: 97%; height: 100%; font-size: medium;">{{feed.description}}</span>
                                        </div>
                                        <div style="width: 5%; height: 100%; display: flex; padding-top: 1%;">
                                            <mat-icon>bookmark_border</mat-icon>
                                        </div>
                                    </div>

                                    <div style="width: 100%; height: 50%; display: flex;">
                                        <div style="width: 94%; height: 100%; display: flex;">
                                            <span style="width: 97%; font-size: small;" class="feedsDescTwoLineStyle">{{feed.contentDetails}}</span>
                                        </div>
                                    </div>

                                    <!-- <div style="width: 100%; height: 25%; display: flex;">
                                        <div style="width: 94%; height: 100%; display: flex;">
                                            <span style="width: 97%; font-size: small;" class="elipsis-text">{{feed.contentDetails}}</span>
                                        </div>
                                    </div> -->

                                    <!-- <div style="width: 98%; height: 30%; display: flex;">
                                        <div style="height: 100%; text-align: end;">#</div>
                                        <div style="width: 88%; height: 100%; display: flex; justify-content: flex-start;">
                                            <div *ngFor="let tag of feed.tags" class="tag-field">
                                                <span style="font-size: small;">{{tag}}</span>
                                            </div>
                                        </div>
                                    </div> -->
                                </div>
                            </div>
                      </div>
                </div>
        </div>
    
        <div style="width: 5%;height: 100%;"></div>
    
        <div style="width: 47.5%;height: 100%;">
    
            <div style="width: 100%;height: 50%;">
                <div class="cardHeader fontAndFamily " style="height: 12%; font-weight: bold;max-height: 35px;">
                    Jobs
                </div>
                <div style="height: 4%;"></div>
                <div class="cardBodyHolder">
                        <div *ngFor="let job of jobOpenings" style="display: flex;" (click)="detailView('jobOpenings',job.id)" class="cardBodyMedium boxShadow">
                            <div style="width: 15%; height: 100%; padding: 6px;">
                                <div style="width: 100%; height: 100%;">
                                    <img *ngIf="isMetadataAvailable(job)" [src]="job.linkMetaData?.image" style="width: 100%; height: 100%;" />
                                    <img *ngIf="!isMetadataAvailable(job)" src="../assets/link.png" style="width: 100%; height: 100%;" />
                                </div>
                            </div>
                            <div style="width: 81%; height: 100%; margin-left: 4px; display: flex;">
                                <div style="width: 70%; height: 100%; display: flex; align-items: center;">
                                    <div style="width: 100%; display: grid;">
                                        <span class=" elipsis-text headdingColourAndWeight" style="width: 100%;">{{job.description}}</span>
                                        <span style="width: 100%; font-size: small;">{{job.employer}}</span>
                                    </div>
                                </div>
                                <div style="width: 30%; height: 100%; display: flex; align-items: center;">
                                    <div style="width: 95%; height: 100%; display: flex; align-items: center;">
                                        <div style="width: 100%; display: grid;">
                                            <div style="width: 100%; display: flex; font-size: small; align-items: center;">
                                                <img src="../assets/location.png" width="16px" height="16px" style="margin-right: 4px;">
                                                <!-- <mat-icon style="margin-right: 4%;"> location_on</mat-icon> -->
                                                {{job.location}}
                                                <!-- <div style="width: 20%;">
                                                </div>
                                                <div style="width: 80%;">
                                                </div> -->
                                            </div>
                                            <div style="width: 100%; display: flex; font-size: small; align-items: center;">
                                                <img src="../assets/job.png" width="16px" height="16px" style="margin-right: 4px;">

                                                <!-- <mat-icon style="margin-right: 4%;">business_center</mat-icon> -->
                                                {{job.category}}
                                                <!-- <div style="width: 20%;">
                                                </div>
                                                <div style="width: 80%;">
                                                </div> -->
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <div style="width: 50%; height: 100%; display: flex; align-items: center;">
                                        <div style="width: 100%; display: grid;">
                                            <div style="width: 100%; display: flex; font-size: small; align-items: center;">
                                                <mat-icon style="margin-right: 4%;"> location_on</mat-icon>
                                                {{job.domain}}
                                                
                                            </div>
                                            <div style="width: 100%; display: flex; font-size: small; align-items: center;">
                                                <mat-icon style="margin-right: 4%;">business_center</mat-icon>
                                                {{job.applyUrl}}
                                              
                                            </div>
                                        </div>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                </div>
            </div>
            <div style="width: 100%;height: 2%;"></div>  
            <div id="questionbox" style="width: 100%;height: 49%;">
                <div class="cardHeader fontAndFamily " style="height: 12%;font-weight: bold;max-height: 35px;">
                    Tech Talk
                </div>
                <div style="height: 4%;"></div>
                <div class="cardBodyHolder">
                        <div *ngFor="let question of questions" (click)="detailView('questions',question.id)" class="cardBodyMedium boxShadow">
                            <div style="width: 100%; height: 100%; padding: 6px; display: flex; align-items: center;">
                                <div style="width: 70%; height: 100%; display: flex; align-items: center;">
                                   
                                   
                                    <div style="width: 100%; height: 100%;">
                                        <div style="width: 100%; height: 45%; display: flex;">
                                            <div style="width: 99%; height: 100%; display: flex;">
                                                <span class="elipsis-text headdingColourAndWeight" style="width: 97%; height: 100%; font-size: medium;">{{question.description}}</span>
                                            </div>
                                        
                                        </div>
    
                                        <div style="width: 100%; height: 50%; display: flex;">
                                            <div style="width: 99%; height: 100%; display: flex;">
                                                <span style="width: 100%; font-size: small;" class="feedsDescTwoLineStyle">{{question.contentDetails}}</span>
                                            </div>
                                        </div>
    
                                    
                                    </div>
                                    <!-- <div style="width: 100%; display: grid; height: 100%;">
                                        <span style="width: 90%;" class="elipsis-text headdingColourAndWeight">{{question.description}}</span>
                                        <span style="width: 95%; font-size: small;" class="elipsis-text">{{question.contentDetails}}</span>
                                    </div> -->



                                </div>
                                <div style="width: 30%; height: 100%; display: flex; align-items: center;">
                                    <div style="width: 100%; display: grid;">
                                        <div style="width: 100%; display: flex; font-size: small; align-items: center;">
                                            <img src="../assets/domain.svg" width="16px" height="16px" style="margin-right: 4px;">
                                            <!-- <mat-icon style="margin-right: 4%;"> location_on</mat-icon> -->
                                            {{question.domain}}
                                            <!-- <div style="width: 15%;">
                                            </div>
                                            <div style="width: 85%;">
                                            </div> -->
                                        </div>
                                        <div style="width: 100%; display: flex; font-size: small; align-items: center;">
                                            <img src="../assets/type.svg" width="16px" height="16px" style="margin-right: 4px;">

                                            <!-- <mat-icon style="margin-right: 4%;">business_center</mat-icon> -->
                                            {{question.category}}
                                            <!-- <div style="width: 15%;">
                                            </div>
                                            <div style="width: 85%;">
                                            </div> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                </div>
            </div>
    
        </div>
    </div>
</div>
